import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { URI } from '../../Conexiones/Conexion';
import '../../CSS/Empleados.css'
import {  FaEdit, FaUserCheck} from "react-icons/fa";
import { BsPlus } from 'react-icons/bs';
import { FcCheckmark } from "react-icons/fc";
import { IoClose } from "react-icons/io5";
import ModalAsisOfi from './ModalAsisOfi';
import EditarAsisOfi from './EditarAsisOfi';
import moment from "moment/moment";
import { IoArrowUndo } from "react-icons/io5";
import { useNavigate } from 'react-router';
import { getToken } from '../../Conexiones/Conexion';
import AgregarAsisOfi from './AgregarAsisOfi';
import { MdTimerOff } from 'react-icons/md';

function TablaAsisOficina() {

    const [asistenciaOfi,setAsisOfi]=useState([])
    const [listaOfi,setOfi]=useState([])
    const [busqueda,setBusqueda] = useState ('')
    const navigate = useNavigate()

    const day = moment().isoWeekday()

    useEffect (()=>{
        const getAsistencia = async () =>{
            const res = await axios.get(URI+'/asistencia-oficina/',{
                headers: {
                    'Authorization': `Bearer ${getToken()}`
                },
                }).catch(
                    err =>{
                        if(err.response.data === "Token Inválido" | err.response.data === "Token requerido"){
                            navigate('/')
                        }
                    }
                )
            setAsisOfi(res.data.asistencia)
            console.log(res.data.asistencia);
            setOfi(res.data.asistencia)
        }
        getAsistencia()
    },[navigate])

    

    const buscar = e => {
        setBusqueda(e.target.value)
        filtrar(e.target.value)
        console.log(e.target.value)
    }


    const filtrar= (textoIngresado) =>{
        var resultadoBusqueda = listaOfi.filter((elemento)=> {
        if  (elemento.nombreEmp.toString().toLowerCase().includes(textoIngresado.toLowerCase()) 
        || elemento.fecha.toString().toLowerCase().includes(textoIngresado.toLowerCase())
        ){  return elemento; }
        return resultadoBusqueda;
        });
        setAsisOfi(resultadoBusqueda);
    }

    const regresar = () => {
        navigate('/inicio/oficina')
    }

    return (
        <div>
        <div className="tablaHerramientas">

            <div >
            <h3 className="text-uppercase">ASISTENCIA DE OFICINA</h3>
        </div>

           <ModalAsisOfi/>
           <div >
            <IoArrowUndo title="REGRESAR" onClick={regresar} style={{position:'absolute', right:'40px', top:'60px', fontSize:'40px', cursor:'pointer', color:'#1A2E4F'}}/>
        </div>
        <div className='divboton' >                                                                                             
                <div className='boton'  style={{display:'flex', justifyContent:'space-between'}}>
                {day === 7 ?(
                <button style={{justifyContent:'center'}}  disabled className="btn btn-light btncolor" type="button">
                    <label className="agregar">ASISTENCIA</label><BsPlus style={{fontSize:'25px'}}/>
                </button>
                 ):(
                    <button style={{justifyContent:'center'}}  className="btn btn-light btncolor" data-bs-toggle="modal" data-bs-target="#modal-agregar" type="button">
                    <label className="agregar">ASISTENCIA</label><BsPlus style={{fontSize:'25px'}}/>
                    </button>
                )}
                            <input className="form-control " style={{width:'50%'}} type="search"  value={busqueda} placeholder="Empleado,fecha" onChange={buscar} aria-label="Search"/> 
            </div>
        </div>  
        <AgregarAsisOfi/>
        <div className='divboton' >
                {day !==7 ?(
                    <div className='boton'>
                    <button  className="btn btncolor" data-bs-toggle="modal" data-bs-target="#modal-agregar-asistencia">
                        <label className="agregar">AGREGAR ASISTENCIA &nbsp;</label><FaUserCheck title="ASISTENCIA" style={{fontSize:'20px'}}/>
                    </button>
                </div>
                ):(
                    <div className='boton'>
                        <button  className="btn btncolor" disabled>
                            <label className="agregar">AGREGAR ASISTENCIA &nbsp;</label><FaUserCheck title="ASISTENCIA" style={{fontSize:'20px'}}/>
                        </button>
                    </div>
                )}
            </div>

            { asistenciaOfi.length === 0 ? (<h3 style={{marginTop:'30vh'}}>NO HAY REGISTROS</h3>):(
            <div className="caja-asistencia" >
                <div className="table tabla">
                    <table className="table table-hover table-bordered text-uppercase">
                        <thead className="encabezado">
                            <tr >
                                <th>EMPLEADO</th>
                                <th>L</th>
                                <th>M</th>
                                <th>M</th>
                                <th>J</th>
                                <th>V</th>
                                <th>S</th>
                                <th>EDITAR</th>
                            </tr>
                        </thead>
                        <tbody >
                            {asistenciaOfi.map(p =>{
                                return(
                                    <tr key={p.num}>
                                        <td>{p.nombreEmp}</td>
                                        <td>
                                            {p.lunes=== 1 ? (<FcCheckmark size={25} />):(
                                            p.lunes === 0.5 ? (<MdTimerOff size={25} color="#1A2E4F" />)
                                            :(p.lunes === 0 ? (<IoClose size={30} color="red" /> ) :(null)))}
                                        </td>
                                        <td>
                                            {p.martes === 1 ? (<FcCheckmark size={25}  />):(
                                            p.martes === 0.5 ? (<MdTimerOff size={25} color="#1A2E4F"  />):
                                            (p.martes === 0 ? (<IoClose size={30} color="red" />) :(null)))}
                                        </td>
                                        <td>
                                            {p.miercoles === 1 ? (<FcCheckmark size={25} />):(
                                            p.miercoles === 0.5 ? (<MdTimerOff size={25} color="#1A2E4F" />)
                                            :(p.miercoles === 0 ? (<IoClose size={30} color="red" /> ) :(null)))}
                                        </td>
                                        <td>
                                            {p.jueves === 1 ? (<FcCheckmark size={25} />):(
                                            p.jueves === 0.5 ? (<MdTimerOff size={25} color="#1A2E4F"/>)
                                            :(p.jueves === 0 ? (<IoClose size={30} color="red" /> ) :(null)))}
                                        </td>
                                        <td>
                                            {p.viernes === 1 ? (<FcCheckmark size={25} />):(
                                            p.viernes === 0.5 ? (<MdTimerOff size={25} color="#1A2E4F" />)
                                            :(p.viernes === 0 ? (<IoClose size={30} color="red" /> ) :(null)))}
                                        </td>
                                        <td>
                                            {p.sabado === 1 ? (<FcCheckmark size={25}/>):(
                                            p.sabado === 0.5 ? (<MdTimerOff size={25} color="#1A2E4F" />)
                                            : (p.sabado === 0 ? (<IoClose size={30} color="red" /> ) :(null)))}
                                            </td>
                                        {/*<td>{p.observacion}</td>
                                        <td>{moment(p.fecha).format("DD-MM-YYYY")}</td>*/}
                                        <td>
                                            <FaEdit size={20} cursor="pointer" title="EDITAR"  />           
                                            </td>
                                    </tr>
                                )
                            })}                        
                        </tbody>
                    </table>
                </div>           
            </div>
        )}
        </div>
        </div>
    );
}

export default TablaAsisOficina;